import {
  useQuery,
  useQueryClient,
  type UseQueryResult,
} from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { useAuth } from "@/modules/auth/hooks/useAuth";
import type { PersonalDashboard, PlatformDashboard } from "../types";

const PERSONAL_KEY = ["dashboard", "personal"] as const;
const PLATFORM_KEY = ["dashboard", "platform"] as const;

export function usePersonalDashboard(): UseQueryResult<PersonalDashboard> {
  const { accessToken } = useAuth();
  return useQuery({
    queryKey: [...PERSONAL_KEY, accessToken ? "auth" : "anon"],
    enabled: !!accessToken,
    queryFn: () =>
      apiFetch<PersonalDashboard>("/dashboard/personal", {
        token: accessToken,
      }),
    refetchInterval: 5 * 60 * 1000,
    staleTime: 2 * 60 * 1000,
  });
}

export function usePlatformDashboard(): UseQueryResult<PlatformDashboard> {
  const { accessToken } = useAuth();
  return useQuery({
    queryKey: [...PLATFORM_KEY, accessToken ? "auth" : "anon"],
    enabled: !!accessToken,
    queryFn: () =>
      apiFetch<PlatformDashboard>("/dashboard/platform", {
        token: accessToken,
      }),
    refetchInterval: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
  });
}

export function useRefreshDashboard() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: ["dashboard"] });
  };
}
